import { toast } from 'vuetify-sonner';

export function notifyNotImplemented(name: string) {
    toast.info(`"${name}" is not yet implemented.`);
}

export function useNotImplemented() {
    return notifyNotImplemented;
}
